var Utils = require('./utils');
var Hogan = require('hogan.js');

var data, max = {};
var $tableWrapper = $('.table-wrapper');
var $table = $tableWrapper.find('#js-table');

import Templates from './templates';

var resultTemplatePop = Templates.tableTemplatePop;
var resultTemplateDistance = Templates.tableTemplateDistance;

var tableLength = Utils.isMobile ? 20 : 20;
var currentTable = null;

function init(_data) {

  data = _data.map((el) => {
    return {
      name : el.name,
      pop: el.pop,
      dist: el.dist,
      formattedPop: el.formattedPop,
      formattedDist: el.formattedDist,
      value_rang : el.value_rang,
      value2_rang : el.value2_rang,
      country: el.country_de,
    }
  });
  
  max.pop = data[0].pop;
  max.quota = 450;

  createPopTable();

  $tableWrapper.removeClass('table-loading')
  $table.css('opacity', 1);
  $tableWrapper.find('.btn').on(Utils.clickEvent, switchTableType);

  if(!Utils.isMobile){
    $table.addClass('fixed-height');
    $('.top-number').text(tableLength);
  }
}

function createPopTable(){
  if (currentTable === 'pop') {
    return false;
  }

  var sortedData = data.sort(Utils.sortData('pop'));
    
  var tableData = sortedData
    .filter(filterLimit)
    .map(mapData('pop'));

  $table.html(resultTemplatePop.render({ tableType: 'Zugezogene', tabledata : tableData }));

  currentTable = 'pop';
}

function createDistTable(){
  if (currentTable === 'dist') {
    return false;
  }

  var sortedData = data.sort(Utils.sortData('dist'));
    
  var tableData = sortedData
    .filter(filterLimit)
    .map(mapData('dist'));

  $table.html(resultTemplateDistance.render({ tableType: 'dist', tabledata : tableData }));
  currentTable = 'dist';
}

function mapData(key){
  return (el, i) => {
    return {
      name : el.name,
      num: Utils.numberFormat(el[key]) + '',
      width : (el[key] / max[key]) * 100,
      index : i + 1,
      country: el.country,
      formattedPop: el.formattedPop,
      formattedDist: el.formattedDist,
      value_rang : el.value_rang,
      value2_rang : el.value2_rang,
      isPop: key === 'pop',
      pop: Utils.numberFormat(el.pop)
    };
  }
}

function filterLimit(el, i){
  return i < tableLength;
}

function switchTableType(){
  var $this = $(this);
  var tableType = $this.attr('data-type');

  $this.siblings().removeClass('active');
  $this.addClass('active');

  if(tableType === 'pop'){
    return createPopTable();
  }

  createDistTable();
}

module.exports = {
  init : init
}